/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const SET_PC_MENU_OPTIONS = 'SET_PC_MENU_OPTIONS';
export const SET_PC_SETTING_VERTICAL_LIMIT = 'SET_PC_SETTING_VERTICAL_LIMIT';
export const SET_PC_SETTINGS_HIGHLIGHT_POSITION = 'SET_PC_SETTINGS_HIGHLIGHT_POSITION';
export const SET_PC_STATE = 'SET_PC_STATE';
